import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithReAuth } from './api';
import {
  GetNotificationResponse,
  GetNotificationsPayload,
  GetNotificationsResponse
} from '../interfaces/notification.interface';

const BASE_URL = `${import.meta.env.VITE_BACKEND_URL}/api/notifications`;

export const apiNotifications = createApi({
  reducerPath: 'apiNotifications',
  baseQuery: (...args) => baseQueryWithReAuth(...args, { baseUrl: BASE_URL }),
  tagTypes: ['CategoryNotifications', 'Notification'],
  endpoints: (build) => ({
    getNotifications: build.query<GetNotificationsResponse, GetNotificationsPayload>({
      query: ({ category, isRead, limit } = {}) => ({
        url: `/`,
        method: 'GET',
        params: {
          category,
          isRead,
          limit
        }
      }),
      providesTags: ['CategoryNotifications']
    }),

    getNotification: build.query<GetNotificationResponse, string>({
      query: (notiicationId) => ({
        url: `/${notiicationId}`,
        method: 'GET'
      }),
      providesTags: ['Notification']
    }),
    syncConfluenceNotifications: build.mutation({
      query: () => ({
        url: '/syncConfluenceNotifications',
        method: 'POST'
      }),
      invalidatesTags: ['CategoryNotifications']
    }),
    markNotificationAsRead: build.mutation({
      query: (notificationId) => ({
        url: '/markOneAsRead',
        method: 'POST',
        body: { notificationId }
      }),
      invalidatesTags: ['CategoryNotifications']
    }),
    markAllNotificationsAsRead: build.mutation({
      query: () => ({
        url: '/markAllAsRead',
        method: 'POST'
      }),
      invalidatesTags: ['CategoryNotifications']
    })
  })
});

export const {
  useGetNotificationsQuery,
  useGetNotificationQuery,
  useSyncConfluenceNotificationsMutation,
  useMarkNotificationAsReadMutation,
  useMarkAllNotificationsAsReadMutation,
  useLazyGetNotificationsQuery
} = apiNotifications;
